import React from 'react';
import Editor from '@monaco-editor/react';
import PropTypes from 'prop-types';
import { ModelPropType } from '../ModelPropTypes';

const CodeEditorComponent = ({ model, value, onChange }) => {

  return (
    <div style={{
      height: model.properties?.container?.height || '200px',
      width: model.properties?.container?.width || ''
    }}>
      <Editor
        height={model.properties?.height || ''}
        width={model.properties?.width || ''}
        defaultLanguage={model.properties?.language ?? 'json'}
        defaultValue={value}
        onChange={onChange}
      />
    </div>
  );
};

CodeEditorComponent.propTypes = {
  model: ModelPropType,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default React.memo(CodeEditorComponent);
